import React from "react";
import { RouteComponentProps, Switch } from "react-router-dom";
import PrivateRoute from "../../../layout/PrivateRoute";
import CommissionReportDetails from "./CommissionReportDetails";
import CommissionReports from "./CommissionReports";

interface Props extends RouteComponentProps<{}> {}

const CommissionReportsData: React.FC<Props> = (props) => {
  return (
    <Switch>
      <PrivateRoute
        path={`${props.match.path}/:commissionReportId`}
        component={CommissionReportDetails as any}
      />
      <PrivateRoute
        path={props.match.path}
        component={CommissionReports as any}
      />
    </Switch>
  );
};

export default CommissionReportsData;
